/**
 * 镜头运动选择器（仅当模型 enableCameraMovement 时显示）
 */

import type { CameraMovement } from '../services/videoApi';

interface VideoCameraMovementSelectorProps {
  value: CameraMovement | undefined;
  onChange: (value: CameraMovement | undefined) => void;
}

interface CameraMovementOption {
  id: CameraMovement;
  label: string;
}

const OPTIONS: CameraMovementOption[] = [
  { id: 'static', label: '静止' },
  { id: 'pan_left', label: '向左平移' },
  { id: 'pan_right', label: '向右平移' },
  { id: 'zoom_in', label: '推进' },
  { id: 'zoom_out', label: '拉远' },
  { id: 'tilt_up', label: '向上俯仰' },
  { id: 'tilt_down', label: '向下俯仰' },
];

export function VideoCameraMovementSelector({
  value,
  onChange,
}: VideoCameraMovementSelectorProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-light-text">镜头运动</span>
        {value && (
          <button
            type="button"
            className="text-xs text-light-muted hover:text-accent-blue"
            onClick={() => onChange(undefined)}
          >
            清除
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {OPTIONS.map((opt) => {
          const isActive = opt.id === value;
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => onChange(isActive ? undefined : opt.id)}
              className={`px-3 py-1.5 rounded-lg border text-sm transition-all ${
                isActive
                  ? 'border-accent-blue bg-accent-blue text-white shadow-md'
                  : 'border-light-border bg-white text-light-secondary hover:border-accent-blue hover:text-accent-blue'
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
